"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DropdownExperimentalLayout = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _dropdownList = require("../../../helpers/dropdown-list");

var _layout = require("../../../layout");

var _popover = require("../../../popover");

var _screenReaderOnly = require("../../../screen-reader-only");

var _core = require("@emotion/core");

var DropdownExperimentalLayout = function DropdownExperimentalLayout(_ref) {
  var dropdownListComponent = _ref.dropdownListComponent,
      dropdownTriggerProps = _ref.dropdownTriggerProps,
      getMenuProps = _ref.getMenuProps,
      isOpen = _ref.isOpen,
      isMulti = _ref.isMulti,
      labelId = _ref.labelId,
      labelText = _ref.labelText,
      popoverControllerProps = _ref.popoverControllerProps,
      searchInputRef = _ref.searchInputRef,
      triggerButtonProps = _ref.triggerButtonProps,
      triggerContent = _ref.triggerContent,
      triggerRef = _ref.triggerRef,
      ulRef = _ref.ulRef,
      width = _ref.width;
  var describedById = labelId ? "".concat(labelId, "-trigger") : undefined;

  var handleOnOpened = function handleOnOpened() {
    if (searchInputRef.current) searchInputRef.current.focus();else if (ulRef.current) ulRef.current.focus();

    if (popoverControllerProps && popoverControllerProps.onOpened) {
      popoverControllerProps.onOpened();
    }
  }; // Adds a gap between popover and window's bottom position


  var popoverContentMaxHeight = 'calc(100vh - 90px)';
  return (0, _core.jsx)(_react.default.Fragment, null, (0, _core.jsx)(_screenReaderOnly.ScreenReaderOnly, {
    id: labelId,
    hidden: true
  }, labelText), (0, _core.jsx)(_dropdownList.DropdownTrigger, (0, _extends2.default)({}, dropdownTriggerProps, triggerButtonProps, {
    "aria-labelledby": labelId,
    "aria-describedby": describedById,
    shouldUseStencilButton: true
  }), (0, _core.jsx)("span", {
    id: describedById
  }, triggerContent)), !isOpen && (0, _core.jsx)("ul", (0, _extends2.default)({}, getMenuProps({}, {
    suppressRefError: true
  }), {
    role: "listbox",
    "aria-multiselectable": isMulti ? 'true' : undefined,
    "aria-hidden": isOpen ? 'false' : 'true',
    style: {
      margin: 0
    }
  })), (0, _core.jsx)(_popover.PopoverController, (0, _extends2.default)({}, popoverControllerProps, {
    isOpen: isOpen,
    target: triggerRef,
    close: function close() {
      return null;
    },
    onOpened: handleOnOpened
  }), (0, _core.jsx)(_layout.Row, {
    minWidth: width,
    maxHeight: popoverContentMaxHeight
  }, dropdownListComponent)));
};

exports.DropdownExperimentalLayout = DropdownExperimentalLayout;